export const projectOutputList = [
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section4_slide_img1.gif',
    titlePc: '(마케팅) 텍스트 및 이미지 기반 \n사용자의 감성과 목적에 맞춘 카페 추천 시스템',
    titleM: '(마케팅) 텍스트 및 이미지 기반 사용자의 감성과 목적에 맞춘 카페 추천 시스템',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section4_slide_img2.gif',
    titlePc: '(엔터테인먼트) 음원 차트 데이터를 활용한 \n걸그룹 ITZY 매출 증대 방안',
    titleM: '(엔터테인먼트) 음원 차트 데이터를 활용한 걸그룹 ITZY 매출 증대 방안',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section4_slide_img3.gif',
    titlePc: '(엔터테인먼트) 앨범 및 콘서트 데이터 기반 \n엔터테인먼트 전략',
    titleM: '(엔터테인먼트) 앨범 및 콘서트 데이터 기반 엔터테인먼트 전략',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section4_slide_img4.gif',
    titlePc: '(마케팅) 미래 소비 예측 모델 \n개발 및 소비 유형 분석',
    titleM: '(마케팅) 미래 소비 예측 모델 개발 및 소비 유형 분석',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section4_slide_img5.gif',
    titlePc: '(마케팅) 항공사 이용 고객 만족도 \n예측 모델 개발 및 분석',
    titleM: '(마케팅) 항공사 이용 고객 만족도 예측 모델 개발 및 분석',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section4_slide_img6.gif',
    titlePc: '(스포츠) 한국 프로야구(KBO) \n경기 승률 예측 모델 개발',
    titleM: '(스포츠) 한국 프로야구(KBO) 경기 승률 예측 모델 개발',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section4_slide_img7.gif',
    titlePc:
      '(스포츠) MLB 구단주와 감독 및 선수를 위한 \n포스트 시즌 진출 여부 & 연봉 & 선수 커리어 예측',
    titleM:
      '(스포츠) MLB 구단주와 감독 및 선수를 위한 포스트 시즌 진출 여부 & 연봉 & 선수 커리어 예측',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section4_slide_img8.gif',
    titlePc: '(의료) 개인의 건강지표 및 환경적 요인을 활용한 \n만성질환 예측모델 개발',
    titleM: '(의료) 개인의 건강지표 및 환경적 요인을 활용한 만성질환 예측모델 개발',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section4_slide_img9.gif',
    titlePc: '(제조) 제조 공정 생산성 \n개선 데이터 분석',
    titleM: '(제조) 제조 공정 생산성 개선 데이터 분석',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section4_slide_img10.gif',
    titlePc: '(e스포츠) 팀/선수 지표 가공을 통한 \n경기 분석 및 전략 지원/사전 승패 예측',
    titleM: '(e스포츠) 팀/선수 지표 가공을 통한 경기 분석 및 전략 지원/사전 승패 예측',
  },
]

export const curriculumSimplelList = [
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section5_icon1.png',
    title: 'Python',
    desc: 'AI 프로젝트 수행을 위한 \n프로그래밍 언어',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section5_icon2.png',
    title: '자료구조와 알고리즘',
    desc: '논리적인 프로그램 설계를 위한 필수 교과',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section5_icon3.png',
    title: 'SQL',
    desc: '데이터를 저장하고  \n관리할 수 있는 방법',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section5_icon4.png',
    title: 'BS4, Selenium',
    desc: '인터넷에 널리 퍼져 있는 데이터를 가져오기 위한 도구',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section5_icon5.png',
    title: 'Numpy',
    desc: '데이터를 수학에서의 행렬 처럼 다룰 수 있는 기능',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section5_icon6.png',
    title: 'Pandas',
    desc: '데이터를 이해하고 가공할 수 있는 기능',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section5_icon7.png',
    title: 'Matplotlib, Seaborn',
    desc: '데이터를 그래프로 그려 해석하기 위한 기능',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section5_icon8.png',
    title: 'EDA',
    desc: '데이터를 이해할 수 있는 다양한 수학적 통계 분석 기법을 학습',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section5_icon9.png',
    title: 'Tableau',
    desc: '삼성 등의 대기업에서도 사용하는 데이터 시각화 분석 도구',
  },
  {
    imgUrl:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section5_icon10.png',
    title: '머신러닝/딥러닝',
    desc: '데이터를 알고리즘에 학습시켜 일반화된 정답을 예측하는 기술',
  },
]

export const curriculumDetailList = [
  {
    id: 0,
    step: '1개월',
    title: 'Python과 컴퓨터공학 역량',
    contents: [
      {
        contentsIntro:
          '데이터를 다루는 일을 할 때는 Python 언어를 많이 \n사용합니다. Python 언어에 대해 자세히 살펴보고 \n여러가지 알고리즘과 데이터 저장과 관리 기법을 학습하여 개발의 자신감을 가질 수 있는 시간이에요.',
        contentsInner: [
          'Python 기본 문법',
          '연산자와 제어문',
          '데이터 관리 요소들',
          '함수와 모듈',
          '객체지향 프로그래밍함수와 모듈',
          '다양한 자료구조 사용 실습',
          '알고리즘 이론 및 실습',
          '데이터 베이스 기초',
          '조인과 서브쿼리',
          '데이터 베이스 와 테이블 관리',
        ],
      },
    ],
  },
  {
    id: 1,
    step: '2개월 ~ 3개월',
    title: '데이터 수집과 분석',
    contents: [
      {
        contentsIntro:
          '데이터를 읽고 이해하는 능력을 갖추면 세상의 모든 \n일들의 원인을 파악하고 결과를 예측해볼 수 있습니다. \n이번 과정에서는 데이터를 수집하고 가공하며 이해할 수 있는 능력을 갖출 수 있어요.',
        contentsInner: [
          '데이터 수집',
          '데이터 분석을 위한 Python 라이브러리들',
          '통계학',
          '탐색적 데이터 분석 (EDA)',
          '태블로를 통한 데이터 분석 및 시각화',
        ],
      },
    ],
  },
  {
    id: 2,
    step: '4개월',
    title: '인공지능',
    contents: [
      {
        contentsIntro:
          '사람이 이해한 데이터는 인공지능 알고리즘을 이용하여 컴퓨터에게도 이해시킬 수 있어요. 컴퓨터가 데이터를 \n이해하면 유사한 데이터에 대한 결과를 예측할 수 \n있어요. 이를 통해 다양한 문제를 사람 대신 컴퓨터가 \n해결할 수 있습니다. 이제 사람이 이해한 데이터를 컴퓨터에게 학습을 시켜 미래의 결과를 예측하는 방법을 \n배울 수 있어요.',
        contentsInner: [
          '인공지능 알고리즘에 대한 이해',
          '인공지능 알고리즘의 평가',
          '다양한 문제를 해결하기 위한 인공지능 프로젝트 수행 방법',
          '딥러닝을 이용하여 보다 다양한 형태의 문제를 해결하는 방법',
        ],
      },
      {
        contentsIntro: '프로젝트',
        contentsInner: [
          '가설을 세우고 가설을 입증할 수 있는 데이터를 수집합니다. 수집한 데이터를 통해 세워진 가설이 맞는지 증명하기 위한 데이터 분석 프로젝트를 수행합니다.',
        ],
      },
    ],
  },
  {
    id: 3,
    step: '5개월',
    title: '파이널/데이터톤 프로젝트',
    contents: [
      {
        contentsIntro:
          '지금까지 배운 내용을 토대로 프로젝트를 수행하여 \n봅니다. 주제를 직접 선정하고 데이터에 대한 수집, \n분석, 가공 등의 작업을 직접하게 됩니다. 또한 인공 \n지능 프로젝트가 가능한 데이터인 경우 컴퓨터에게 \n학습을 시켜 미래에 발생되는 데이터를 예측하게 하는 프로젝트도 수행합니다.',
        contentsInner: [
          '주제 선정',
          '데이터 수집 및 탐색',
          '탐색적 데이터 분석(EDA)',
          '인공지능 모델링 및 학습',
          '데이터 분석 리포트 작성',
        ],
      },
    ],
  },
]

interface IContents {
  contentsId: string
  contentsInner: string[]
  contentsCaution?: string
}

interface ISupportSlide {
  imgUrlPc: string
  imgUrlM: string
  step: string
  title: string
  desc?: string
  contents?: IContents[]
}

export const supportSlideList: ISupportSlide[] = [
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/support_slide_img1_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/support_slide_img1_m.png',
    step: '1',
    title: '인턴십 기회 제공',
    desc: '현업 중심 실무 및 협업 경험을 통해 데이터 분석가의 핵심 역량을 쌓을 수 있는 인턴십 프로그램',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/support_slide_img2_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/support_slide_img2_m.png',
    step: '2',
    title: '사전 학습 자료 제공',
    contents: [
      {
        contentsId: 'contents2',
        contentsInner: [
          'a. 데이터 분석 역량 강화를 위한 필수 자료',
          'b. 멋사 VOD 강의(ChatGPT 업무 자동화)',
        ],
        contentsCaution: '* 지원 완료자 혜택으로 제공됩니다.',
      },
    ],
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/support_slide_img3_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/support_slide_img3_m.png',
    step: '3',
    title: '사후 학습 자료 제공',
    contents: [
      {
        contentsId: 'contents3',
        contentsInner: ['a. 멋사 VOD 강의(GA4와 루커 스튜디오, 파이썬 코테 준비, SQLD 자격증)'],
        contentsCaution:
          '* 파이썬 코테 준비, SQLD 자격증 강의는 스터디 지원자 한정으로 제공됩니다.',
      },
    ],
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/support_slide_img4_new_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/support_slide_img4_new_m.png',
    step: '4',
    title: '성취도 평가 진행',
    desc: '2주에 한 번씩 진행되는 과제를 통한 과목별 평가 진행',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/support_slide_img5_new_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/support_slide_img5_new_m.png',
    step: '5',
    title: '취업 준비 관련 이용권 제공',
    contents: [
      {
        contentsId: 'contents5',
        contentsInner: ['a. 원티드 취업지원시스템 EAS 혜택', 'b. 사람인 인적성 검사 이용권'],
      },
    ],
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/support_slide_img6_new_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/support_slide_img6_new_m.png',
    step: '6',
    title: '채용 연계',
    contents: [
      {
        contentsId: 'contents6',
        contentsInner: [
          'a. IT 맞춤형 채용설명회',
          'b. 우수 수료생 대상 추천 채용',
          'c. 이력서 및 면접 코칭',
        ],
      },
    ],
  },
]

export const reviewSlideFirstList = [
  {
    title: '다양한 데이터를 접할 수 있어서 너무 좋았어요',
    reviews: [
      {
        reviewsId: '1',
        reviewsText: [
          '겉핥기로 애매하게만 알던 지식을 많이 내재화 시킬 수 있는 기회라서 너무 좋았습니다.',
          '무엇보다 좋았던건 다양한 데이터로 제가 전처리하고, 가공해본 경험이 좋았습니다.',
          '늘 학교에서 정제된 데이터만 받고, 늘 비슷한 데이터로만 분석을 진행했는데 다양한 데이터를 접할수 있어서 너무 좋았습니다.',
        ],
      },
    ],
    who: '3기 수료생',
  },
  {
    title:
      '이론 및 실습 수업과 세 개의 프로젝트를 통해 더 깊은 지식과 흥미를 이끌어 낼 수 있었어요',
    reviews: [
      {
        reviewsId: '2',
        reviewsText: [
          '또한 타 훈련과정에 존재하지 않는 ‘회고’ 시스템 덕분에 수업 내용을 혼자 공부할 수 있도록 만들어주어 좋았습니다.',
          '온라인 수업이기 때문에 타 수강생들과의 접점이 프로젝트를 제외하면 없을 것 같으나, 으쌰으쌰라는 조 활동을 통해 수강생들과의 소통 공간을 마련해주어 이 부분 또한 좋았습니다.',
        ],
      },
    ],
    who: '2기 수료생',
  },
  {
    title: '조원들과의 협업을 통해 결과물을 만들어 내는 부분이 굉장히 도움이 되었어요',
    reviews: [
      {
        reviewsId: '3',
        reviewsText: [
          '혼자 하는 프로젝트 였다면 절대로 알 수 없었던 부분들도 체크할 수 있습니다. ',
          '실력차이가 나면 나는대로 배우고 가르쳐주며 진행 할 수 있고, 모두가 잘하면 더 좋은 성과를 낼 수 있고, 모두가 못한다고 해도 방향을 정해서 하나하나 해보는 경험이 모두에게 도움이 될 수 있고, 실무는 절대적인 협업 관계이기 때문에, 좋은 배움이 있다고 생각합니다!',
        ],
      },
    ],
    who: '3기 수료생',
  },
]

export const reviewSlideSecondList = [
  {
    title: '데이터 분석을 혼자서 시작하기 어려우신 분들이라면, 도움이 될 것 같아요',
    reviews: [
      {
        reviewsId: '4',
        reviewsText: [
          '이 부트캠프로부터 무엇을 얻을 수 있을까, 정말 고민을 많이 하다가 마음이 이끌리는 대로 신청하고 수강하게 되었습니다.',
          '부트캠프가 지향하는 내용들이 모두 저에게 필요하다고 생각했기 때문인데요, 지금의 저는 그때 얻고자 했던 부분들을 대부분 얻게 되지 않았나 생각합니다.',
          '굉장히 만족스러운 선택이었다고 생각합니다!',
        ],
      },
    ],
    who: '3기 수료생',
  },
  {
    title: '데이터 분석의 기초부터 실습까지 경험해볼 수 있는 좋은 기회였어요',
    reviews: [
      {
        reviewsId: '5',
        reviewsText: [
          '저는 이 훈련과정을 데이터 분석의 "첫걸음"이라고 생각합니다. 수강생중에 비전공자도 많았지만 모두 이해하기 쉽도록 처음부터 이론을 설명해주셔서 좋았습니다!',
          '세번의 프로젝트는 배웠던 이론을 실습으로 더 탄탄하게 잡아주어 좋았습니다.',
          '이번 훈련과정을 바탕으로 데이터 분석에 대한 공부를 더해 취업에 성공할 것 입니다!',
        ],
      },
    ],
    who: '2기 수료생',
  },
  {
    title: '강사님의 강의가 체계적인 커리큘럼으로 진행되어 단계적 이해에 도움이 돼요',
    reviews: [
      {
        reviewsId: '6',
        reviewsText: [
          '강사님이나 매니저님과의 소통이 매우 원활해 어려움이 생겼을 때 도움을 많이 받았습니다.',
        ],
      },
    ],
    who: '3기 수료생',
  },
]

export const reviewSlideThirdList = [
  {
    title:
      '이전에는 진로가 불분명했었는데 이 과정을 수료함으로써 확실히 데이터 분석으로 정해진 것 같아요',
    reviews: [
      {
        reviewsId: '7',
        reviewsText: [
          '데이터 분석 3기 과정을 들으면서 데이터 분석가에 대한 역량을 한 층 키울 수 있었으며, 무엇보다 좋은 강사진과 운영진분들 덕분에 원활하고 더 가치있게 과정 훈련을 했던 것 같습니다',
        ],
      },
    ],
    who: '3기 수료생',
  },
  {
    title: '데이터 분석에 대한 전반적인 이해와 경험을 할 수 있었어요',
    reviews: [
      {
        reviewsId: '8',
        reviewsText: [
          '우수한 강사님과, 서포트를 잘 해주시는 매니저님들이 있어서 강의의 퀄리티에서도 행정적 측면에서도 정말 크게 만족도 있는 프로그램 경험이었습니다.',
          '학생이 성실하게 참여할 수 있도록 힘써주셨고, 따라가지 못해서 정말 큰 걱정이 많았는데 계속 응원해주시고 도와주셔서 취업에 더 집중할 의지가 생겼습니다.',
        ],
      },
    ],
    who: '3기 수료생',
  },
  {
    title: '프로젝트 피드백을 친절하고 이해하기 쉽게 해주셔서 도움이 많이 되었어요',
    reviews: [
      {
        reviewsId: '9',
        reviewsText: [
          '멘토님께서도 열정이 가득하셔서 수강생분들의 질문을 현직자의 입장에서 자세히 설명해주시고 좋은 조언도 많이 해주셨습니다.',
          '공부도 하면서 이를 바탕으로 프로젝트를 진행하는 것이 정말 도움이 많이 되었습니다. 좋은 기회를 주셔서 정말 감사합니다.',
        ],
      },
    ],
    who: '2기 수료생',
  },
  {
    title: '비전공자를 배려하여 최대한 쉬운 단어로 맞춤 설명해주세요',
    reviews: [
      {
        reviewsId: '10',
        reviewsText: [
          '이후 추가적인 질문 발생 시 더 자세하게 설명을 해주시는 부분도 좋았고, 보조강사님이 적극적으로 나서서 어려운 점 물어봐주시고, 관련 자료 공유해주시는 부분도 좋습니다.',
        ],
      },
    ],
    who: '3기 수료생',
  },
]

export const benefitSlideList = [
  {
    title: '교육비 전액 무료',
    desc: '내일배움카드로 약 1,400만원 상당의 \n교육을 무료로 들을 수 있어요',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/benefit_slide_img1_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/benefit_slide_img1_m.png',
    caution: '*만 19세 이상의 내일배움카드 소지자만 \n부트캠프 참여가 가능합니다.',
  },
  {
    title: '훈련장려금 지급',
    desc: '매월 최대 81만 원의 \n훈련 지원금을 받을 수 있어요',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/benefit_slide_img2_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/benefit_slide_img2_m.png',
    caution:
      '*단, 국민취업제도 참여 유형을 포함한 개인의 상황에 따라 다를 수 있으며 자세한 사항은 고용24에서 확인해 주세요.',
  },
  {
    title: '교육 장비 지원',
    desc: '교육 시작 전, 교육 장비가 필요한 인원\n에 한하여 무료로 장비를 대여해 드려요',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/benefit_slide_img3_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/benefit_slide_img3_m.png',
  },
  {
    title: '오프라인 프로젝트 공간 지원',
    desc: '사전 신청자에 한하여 프로젝트를 진행\n할 수 있는 오프라인 공간을 지원해요',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/benefit_slide_img4_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/benefit_slide_img4_m.png',
  },
]

export const ApplyScheduleList = [
  {
    title: '모집기간',
    content: '2월 19일(수) 오후 2시 ~ \n3월 25일(화) 오후 11시',
  },
  {
    title: '합격자 \n발표일',
    contents: [
      '1차 : 2.27(목) 오후 3시 \n(~2월 26일(수) 오후 1시 이전 제출자)',
      '2차 : 3.6(목) 오후 3시 \n(~3월 5일(수) 오후 1시 이전 제출자)',
      '3차 : 3.13(목) 오후 3시 \n(~3월 12일(수) 오후 1시 이전 제출자)',
      '4차 : 3.20(목) 오후 3시 \n(~3월 19일(수) 오후 1시 이전 제출자)',
      '5차 : 3.27 (수) 오후 3시 \n(~3월 25일(화) 오후 11시 이전 제출자)',
    ],
  },
]

export const EduScheduleList = [
  {
    title: '교육 시작',
    content: '2025년 3월 28일',
  },
  {
    title: '교육 종료',
    content: '2025년 8월 19일',
  },
  {
    title: '교육 시수',
    content: '21주 | 760H',
  },
  {
    title: '교육 시간',
    content: '평일 오전 9시 - 오후 6시(일 8시간, 점심시간 제외)',
  },
  {
    title: '학습 형태',
    content: '온라인 교육(실시간 라이브)',
  },
]

export const bootCampFaqTabList = [
  { label: '전체', value: 'all' },
  {
    label: '지원',
    value: 'apply',
  },
  {
    label: '선발',
    value: 'nebeka',
  },
  {
    label: '취업',
    value: 'employment',
  },
  {
    label: '교육운영',
    value: 'edu',
  },
  {
    label: '특전혜택',
    value: 'benefit',
  },
  {
    label: '기타',
    value: 'etc',
  },
]

interface IBootCampFaqList {
  [key: string]: {
    question: string
    answer?: string
    secondAnswer?: string
    externalUrl1?: string
    urlName1?: string
    externalUrl2?: string
    urlName2?: string
    answerList?: string[]
  }[]
}

export const bootCampFaqList: IBootCampFaqList = {
  apply: [
    {
      question: '[지원] 지원 자격이 있나요?',
      answer:
        '국민내일배움카드를 보유하고 있거나 발급 가능하다면 누구든지 지원하실 수 있습니다. 발급 가능 여부는 고용노동부 1350 또는 거주지 관할 고용센터에서 직접 확인해주셔야 합니다. \n국민내일배움카드를 발급받고 교육 기간 동안 주 5일, 매일 약 8시간의 교육 과정에 온전히 참여하실 수 있다면 원칙상 수강할 수 있으나, 직장과 병행해야 해서 정해진 시간에 출석할 수 없고 하루 8시간의 학습 시간을 채울 수 없는 경우 선발에서 제외됨을 알려드립니다.',
    },
    {
      question: '[지원] 국민내일배움카드가 없어도 지원할 수 있나요?',
      answer:
        '지원은 가능합니다. 다만 최종 합격 발표 전까지는 모바일 앱 카드 혹은 실물 카드를 소지하고 있으셔야 합니다. \n모바일 앱 카드의 경우, 신청 당일에 즉시 발급이 가능하지만 오프라인 카드 발급은 최종 수령까지 일주일 이상 소요될 수 있기에 고용노동부 1350을 통해 카드 발급 자격 확인 및 발급 신청을 빠르게 하시는 것을 추천드립니다.',
    },
    {
      question: '[지원] 국민내일배움카드는 반드시 오프라인에서만 발급 받을 수 있나요?',
      answer:
        '국민내일배움카드는 고용24 홈페이지를 통해 신청 가능하며 오프라인과 온라인 모두 발급 받으실 수 있습니다. \n자세한 발급 과정은 아래 링크를 통해 확인 가능합니다.',
      externalUrl1: '/nebeca',
      urlName1: '국민내일배움카드 신청 방법 확인하기 (링크)',
      externalUrl2: '/nebeca/issued',
      urlName2: '국민내일배움카드 모바일 앱 카드 발급 방법 확인하기 (링크)',
    },
    {
      question: '[지원] 비전공자도 지원 가능한가요?',
      answer:
        '네. 지원 가능합니다. 전공과 무관하게 데이터 분석가가 되려는 강한 의지와 계획이 있으시면 됩니다. \n다만, 합격 후 약 5개월 동안 정말 몰입해서 학습을 이어가셔야 합니다. 꾸준한 의지와 학습 습관으로 목표하시는 변화를 만들어내시기 바랍니다.',
    },
    {
      question: '[지원] 다른 부트캠프와 중복 지원 가능한가요?',
      answer:
        '멋쟁이사자처럼이 운영하는 다른 부트캠프와 중복 지원은 불가합니다. 다른 훈련기관이 운영하는 과정에 중복 지원하는 것은 가능합니다. 희망하는 부트캠프에 한해 하나만 지원 가능하므로 신중하게 고민하고 선택해주세요.',
    },
    {
      question: '[지원] 고용24 신청은 언제 할 수 있나요?',
      answer:
        '최종 합격자로 선발된 후, 합격하신 분들께 별도로 안내해 드릴 예정입니다. 안내를 받으신 후 고용24에서 신청해주시면 됩니다.',
    },
    {
      question: '[지원] 지원서 제출 후 수정 가능한가요?',
      answer: '지원서 수정은 불가능합니다. 항목을 미리 검토하신 후 제출하시기 바랍니다.',
    },
  ],
  nebeka: [
    {
      question: '[선발] 선발 절차는 어떻게 되나요?',
      answer:
        '국민내일배움카드 신청 -> 지원서(서류) 제출 -> 최종 합격자 발표 -> 고용24 수강신청 순으로 진행됩니다. 국민내일배움카드 발급에 일주일 이상 소요되므로 발급 신청을 먼저 해주시기 바랍니다.',
    },
    {
      question: '[선발] 2차 취업적합성 검사는 무엇인가요?',
      answer:
        '부트캠프 합류에 앞서 데이터 분석에 대한 기본 이해와 취업에 대한 의지를 확인하고자 하는 누구나 답할 수 있는 간단한 검사입니다.',
    },
    {
      question: '[선발] 합격 확인은 어떻게 하나요?',
      answer:
        '각 단계별로 합격하신 분들께는 E-mail과 SMS로 안내드릴 예정입니다. 발표 일정은 상세페이지를 참고해주세요. \n*발표 일정은 상황에 따라 일부 변경될 수 있습니다.',
    },
  ],
  employment: [
    {
      question: '[취업] 취업 지원 프로그램이 제공되나요?',
      answer:
        '데이터 분석가 인턴십 프로그램 기회와 취업 준비 관련 이용권 등을 제공합니다. \n또한 IT 맞춤형 채용설명회 진행과 우수 수료생 대상 추천 채용, 이력서 및 면접 코칭을 통한 취업 지원을 받으실 수 있습니다.',
    },
  ],
  edu: [
    {
      question: '[교육 운영] 이 부트캠프를 수료하면 어떤 직무로 취업할 수 있나요?',
      answer:
        '멋쟁이사자처럼 데이터 분석 부트캠프를 수료하면 이런 직무를 선택할 수 있어요 \n· Data Analyst\n· Business Analyst\n· Growth Marketer\n더 나아가 이런 직무로 성장할 수 있어요.\n· Data Engineer\n· Data Scientist\n이 과정은 IT 취업을 목표로 하는 비전공자, 데이터 분석 직무로 커리어 전환을 희망하는 직장인, 신입 데이터 분석가로서 경쟁력을 높이고 싶은 취준생에게 적합합니다. 특히 데이터톤을 포함한 3번의 팀 프로젝트 경험과 현직자의 실시간 피드백을 통해 실무 역량을 갖추고, 기업이 원하는 포트폴리오를 만들어 취업 시장에서 차별화된 강점을 가질 수 있습니다. 여러분의 커리어 목표와 부트캠프의 교육 방향이 맞는지 궁금하다면, 상담을 통해 더 자세히 확인해보세요!',
    },
    {
      question: '[교육 운영] 교육 기간 내 커리큘럼을 모두 소화할 수 있을까요?',
      answer:
        '충분히 가능합니다. 멋쟁이사자처럼의 데이터 분석 부트캠프는 5개월 동안 단계적으로 구성된 커리큘럼을 통해 초보자도 무리 없이 학습할 수 있도록 설계되었습니다. \n또한, 강사와 멘토진의 실시간 피드백과 1:1 맞춤 학습 지원 으로 학습 속도에 맞춰 진도를 따라갈 수 있습니다. 수료 후에는 데이터 분석가로서 필요한 이론과 실무 역량을 모두 갖추게 되니 걱정하지 않으셔도 됩니다!',
    },
    {
      question: '[교육 운영] 교육은 어디서 진행되나요?',
      answer:
        '교육은 오프라인이 아닌, 온라인 라이브로 진행되며 국내에서, 거주 지역에 무관하게 학습할 수 있습니다.',
    },
    {
      question: '[교육 운영] 온라인 수업 출결은 어떻게 진행되나요?',
      answer:
        '두 가지 방법으로 출결이 진행됩니다.\n 1. 고용24 앱 설치 후 QR코드 인증(개인 진행)\n 2. 줌 모니터링을 통한 매 시간 출결 체크(운영진 진행, 줌 화면에 얼굴이 정확히 확인되어야 출석 인정)\n추가로, 수업 참여 중 장소 이동은 불가합니다. 장소 이동 시 출결에 불이익이 발생하니 이점 유의 부탁드립니다.',
    },
    {
      question: '[교육 운영] 수업에 빠질 경우 강의를 다시 볼 수 있나요?',
      answer:
        '본 교육 과정은 학습을 포함한 모든 내용을 영상으로 추가 제공하지 않습니다. 따라서 다음 수업 내용을 잘 따라가기 위해서는 반드시 출석해주셔야 합니다.',
    },
    {
      question: '[교육 운영] 교육 기간 중 쉬는 날은 없나요?',
      answer:
        '교육 기간 내 주말, 공휴일에는 교육을 진행하지 않습니다. 수업 외 일정에 관해서는 오리엔테이션에서 자세하게 안내드릴 예정입니다. 교육기간 5개월동안 온전하게 몰입하시는 것을 권유드립니다.',
    },
    {
      question: '[교육 운영] 해외에서도 참여할 수 있나요?',
      answer:
        'KDT 프로그램의 특성상, 해외에서 수강하는 것은 불가능합니다. 교육 참여 중에 해외로 이동하는 것 역시 불가능합니다.',
    },
  ],
  benefit: [
    {
      question: '[특전 혜택] 합격생에게 제공되는 혜택이 있나요?',
      answerList: [
        '· 멋쟁이사자처럼 수료생 커뮤니티 활동 기회를 제공합니다.',
        '· 취업 준비를 위한 자격증 및 코딩테스트 스터디 참여를 지원합니다.',
        '· 기초 학습 및 성장을 위한 유료 강의를 제공합니다.',
        '· 이력서 특강 등 개인 맞춤 성장 프로그램을 제공합니다.',
        '· 정규 과정 수료 전/후 추가 학습을 위한 자료 및 유료 강의를 제공합니다.',
      ],
    },
  ],
  etc: [
    {
      question: '[기타] 훈련장려금을 받을 수 있나요?',
      answer:
        '네. 훈련 장려금은 월 최대 316,000원까지 받으실 수 있으며, 매달 출석률에 따라 차등 지급됩니다. \n국민취업제도에 참여 중인 분들의 경우, 훈련 장려금 외에 추가 훈련 수당을 받으실 수 있으며 \n1유형에 해당하시는 분들은 500,000원의 훈련수당까지 더해 월 최대 816,000원을 지급받으실 수 있고 \n2유형에 해당하시는 분들은 284,000원의 훈련수당까지 더해 월 최대 600,000원을 지급받으실 수 있습니다. \n다만, 개인의 상황에 따라 참여 가능한 유형이 다르고 지급받을 수 있는 금액이 다를 수 있기에 반드시 고용24를 통해 확인 및 신청 바랍니다.',
    },
    {
      question: '[기타] 훈련 자비 부담액은 얼마인가요?',
      answer: '본 교육과정은 내일배움카드를 소지하신 분들을 대상으로 전액 무료로 진행됩니다.',
    },
  ],
}
